import { HeaderBackMusicPracticeWidgetStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Icons } from "components";

const HeaderBackMusicPracticeWidget = ({ room_booking_id }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation(["common"]);

  const _handleClickBack = () => {
    let query = {
      ...queryString.parse(location.search),
    };
    delete query.is_preview;
    const queryStringTemp = new URLSearchParams({
      ...query,
    }).toString();
    navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${room_booking_id}/booking/1?${queryStringTemp}`
    );
  };

  return (
    <HeaderBackMusicPracticeWidgetStyled>
      <div className="btn_hdb" onClick={_handleClickBack}>
        <Icons.ArrowLeft2 color="#482174" />
      </div>
      <div className="hdb_label_block" onClick={_handleClickBack}>
        {/* <Icons.Home /> */}
        {t("Back to Edit Information", { ns: "common" })}
      </div>
    </HeaderBackMusicPracticeWidgetStyled>
  );
};

export default HeaderBackMusicPracticeWidget;
